import React, { useEffect, useState } from "react";
import apiClient from "../axios/axiosInterceptor";
import VoiceSearch from "./VoiceSearch";
import VoicesTable from "./VoicesTable";
import '../modal.scss';
import VoiceCreate from "./VoiceCreate";
import {Slide, toast} from "react-toastify";

function Voices({ loggedInUser }) {
    const [voices, setVoices] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingVoice, setEditingVoice] = useState(null);

    const fetchVoices = async (params) => {
        const baseUrl = `/voices`;
        const queryParams = new URLSearchParams(params);

        try {
            const response = await apiClient.get(baseUrl, {
                params: queryParams,
            });
            setVoices(response.data.list);
        } catch (error) {
            console.error('Error fetching voices:', error);
        }
    };

    useEffect(() => {
        fetchVoices();
    }, []);

    const search = async (name) => {
        const newSearchParams = { name };
        await fetchVoices(newSearchParams);
    };

    const handleCreate = () => {
        setEditingVoice(null);
        setShowModal(true);
    };

    const handleEdit = (voice) => {
        setEditingVoice(voice);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        const url = `/voices/${id}`;

        try {
            await apiClient.delete(url);
            await fetchVoices();
        } catch (error) {
            console.error('Error deleting voice:', error);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSubmitModal = async (voiceData) => {
        const url = editingVoice ?
            `/voices/${editingVoice.id}` :
            `/voices`;

        try {
            if (editingVoice) {
                await apiClient.patch(url, voiceData);
                toast.success('Voice updated!', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            } else {
                await apiClient.post(url, voiceData);
                toast.success('Voice created!', {
                    position: "top-right",
                    autoClose: 3000,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            }
            setShowModal(false);
            await fetchVoices();
        } catch (error) {
            console.error('Error saving voice:', error);
        }
    };

    return (
        <div className="mainBody">
            {!showModal && (
                <>
                    <VoiceSearch onSearch={search} onCreate={handleCreate} />
                    <VoicesTable voices={voices} onEdit={handleEdit} onDelete={handleDelete} />
                </>
            )}
            {showModal && <VoiceCreate voice={editingVoice} onClose={handleCloseModal} onSubmit={handleSubmitModal} />}
        </div>
    );
}

export default Voices;
